module.exports = __webpack_public_path__ + "img/cart-empty.f460255c.png";